import { Subdimensiones } from "../../../../../interfaces/Evaluations";
import EvaluationStates from "../../../../../components/States/EvaluationStatesCircle";
import LawsHeaderRow from "./LawsHeaderRow";
import EvaluationSingleRow from "./EvaluationSingleRow";
import ScrollWithThumb from "./ScrollWithThumb";
import { allYears, allLawsByYear, hasValidEvaluation } from "../../../utils/evaluationHelpers";
import SubdimensionLink from "../../../utils/SubdimensionLink";

interface MobileFixedTableStructuralProps {
    evaluation_subDimension: Subdimensiones[];
    period: string;
    selected_type_indicator: { name: string, id: number };
    selected_dimension: { name: string, id: number } | null;
    right: { right: string, rightId: string };
}

const MobileFixedTableStructural = ({ evaluation_subDimension, period, selected_type_indicator, selected_dimension, right }: MobileFixedTableStructuralProps) => {
    // 📌 Calcular los años únicos de todas las subdimensiones
    const allYearsList = allYears(evaluation_subDimension); // eg. ["1998", "2010", "2023"]

    // 📌 Calcular leyes por año a partir de TODAS las subdimensiones
    const allLawsByYearMap: { [year: string]: { law: string, url?: string | null }[] } = {};
    allYearsList.forEach((year) => {
        allLawsByYearMap[year] = allLawsByYear(evaluation_subDimension, year);
    });

    return (
        <div className="flex flex-col gap-8 w-full">
            {evaluation_subDimension.map((sub) => (
                <div className="border rounded-lg border-system-light-50" key={sub.id}>
                    <div className="p-4 bg-brand-green-1 rounded-t-lg">
                        <p className="text-lsmall text-system-light-40">SUBDIMENSIÓN:</p>
                        <SubdimensionLink
                            selected_dimension={selected_dimension}
                            selected_type_indicator={selected_type_indicator}
                            period={period}
                            value={sub.nombre}
                            subdimension={sub}
                            right={right.right}
                            rightId={right.rightId}
                            disabled={!hasValidEvaluation(sub)}
                        />
                        <div className="flex gap-1 items-center mt-3">
                            <span className="text-lsmall text-system-light-40">ESTADO:</span>
                            <EvaluationStates status={sub.trivalente_subdimension} size={12} />
                        </div>
                    </div>
                    <ScrollWithThumb>
                        <>
                            <LawsHeaderRow
                                evaluation_subDimension={evaluation_subDimension}
                                period={period}
                            />
                            <EvaluationSingleRow
                                subdimensiones={sub}
                                allYearsList={allYearsList}
                                allLawsByYearMap={allLawsByYearMap}
                            />
                        </>
                    </ScrollWithThumb>
                </div>
            ))}
        </div>
    );
};

export default MobileFixedTableStructural;